import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'guides',
    canActivate: [authGuard],
    loadComponent: () => import('./features/guide-admin/guide-admin.component').then(m => m.GuideAdminComponent)
  },
  {
    path: 'product-guides',
    canActivate: [authGuard],
    loadComponent: () => import('./features/product-guide-admin/product-guide-admin.component').then(m => m.ProductGuideAdminComponent)
  },
  {
    path: 'yearbooks/:yearbookId',
    canActivate: [authGuard],
    loadComponent: () => import('./features/editor/editor.component').then(m => m.EditorComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/editor/editor.component').then(m => m.EditorComponent)
  },
];
